export function onElementsReady(selector, callback) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.addedNodes.length) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Ensure it's an element node
            const elements = node.matches(selector)
              ? [node]
              : node.querySelectorAll(selector);
            elements.forEach((element) => callback(element, mutation));
          }
        });
      } else if (
        mutation.type === "attributes" &&
        mutation.target.matches(selector)
      ) {
        // Handle attribute changes on elements that match the selector
        callback(mutation.target, mutation);
      }
    });
  });

  observer.observe(document.body, {
    childList: true, // Observe when elements are added or removed
    subtree: true, // Observe all descendants of body
    attributes: true, // Observe changes to attributes
    attributeFilter: ["data-product-gen-uid"], // Specify which attributes to observe, or leave empty to observe all
  });

  // Initial check in case elements are already present in the DOM
  const initialElements = document.querySelectorAll(selector);
  initialElements.forEach((element) => callback(element));
}
